var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M361.889 474.762L197.817 256.006 361.889 37.237c7.713-10.283 5.627-24.871-4.655-32.582-10.282-7.713-24.871-5.626-32.582 4.655L150.109 242.042a23.273 23.273 0 0 0 0 27.927l174.544 232.72c4.572 6.097 11.56 9.311 18.637 9.311 4.858 0 9.759-1.517 13.945-4.656 10.283-7.713 12.367-22.3 4.654-32.582z"}));
}

Chevron.defaultProps = {"viewBox":"0 0 511.999 511.999"};

module.exports = Chevron;

Chevron.default = Chevron;
